import React, { useCallback, useMemo } from 'react';
import { AtlassianLogo } from '@atlaskit/logo';
import { Box, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import ArrowLeftIcon from '@atlaskit/icon/core/migration/arrow-left';
import { token } from '@atlaskit/tokens';
import { IconButton } from '@atlaskit/button/new';
import { DrawerCloseButton } from '@atlaskit/drawer/compiled';
import { useViewStateContext } from '../context';
import { getDiscoverProductsPageRoute } from '@atlassiansox/product-store-react';
import { useIntl } from 'react-intl-next';
import { messages } from '../../../messages';

const headerInnerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	[media.above.xs]: {
		flexDirection: 'row',
	},
});

const titleStyles = xcss({
	font: token('font.heading.large'),
	fontWeight: token('font.weight.regular'),
	fontFamily: token('font.family.brand.heading'),
	color: 'color.text.subtle',
	marginTop: 'space.0',
	[media.above.xs]: {
		marginLeft: 'space.100',
	},
});

const headerContainerStyles = xcss({
	height: '72px',
	display: 'flex',
	width: '100%',
	alignItems: 'center',
	paddingTop: 'space.250',
	paddingBottom: 'space.250',
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	borderBottomColor: 'color.border',
	borderBottomWidth: 'border.width',
	borderBottomStyle: 'solid',
});

const crossStyles = xcss({
	marginLeft: 'auto',
});

export const ProductStoreHeader = () => {
	const { state, setViewState } = useViewStateContext();
	const showProductStoreTitle = useMemo(() => {
		return state.spa === 'product-store';
	}, [state]);
	const onBackToAllProductsClick = useCallback(() => {
		setViewState((prevState) => ({
			...prevState,
			spa: 'product-store',
			route: getDiscoverProductsPageRoute(),
		}));
	}, [setViewState]);
	const { formatMessage } = useIntl();

	return (
		<Box xcss={headerContainerStyles} testId={'cross-flow-support-header'}>
			{showProductStoreTitle ? (
				<Box xcss={headerInnerStyles}>
					<AtlassianLogo appearance="brand" size="small" />
					<Box as="p" xcss={titleStyles}>
						{formatMessage(messages.productStore)}
					</Box>
				</Box>
			) : (
				<IconButton
					testId="drawer-back-to-all-products-button"
					appearance="subtle"
					shape="circle"
					onClick={onBackToAllProductsClick}
					label={formatMessage(messages.backToAllProducts)}
					icon={ArrowLeftIcon}
				/>
			)}
			<Box xcss={crossStyles}>
				<DrawerCloseButton
					testId="drawer-close-button"
					label={formatMessage(messages.close)}
					icon={CrossIcon}
				/>
			</Box>
		</Box>
	);
};
